module.exports = __webpack_public_path__ + "fonts-3ea65b589caae182e5869e24f673d418-GT-Eesti-Pro-Display-Medium-subset.zopfli.woff";